import { Api } from "../../Api";

export const userNonceService = async (
  walletAddress: string,
  networkId: string | number
) => {
  let url = `/user/nonce`;
  const payload = {
    walletAddress,
    networkId,
  };

  const response = await Api.post(url, payload);
  return response;
};

export const verifySignatureService = async (
  walletAddress: string,
  nonce: string,
  walletType: string,
  networkId: number | string,
  signature: string
) => {
  let url = `/user/verify-signature`;
  const payload = {
    walletAddress,
    nonce,
    walletType,
    networkId,
    signature,
  };

  const response = await Api.post(url, payload);
  return response;
};

export const userLoginService = async (
  walletAddress: string,
  networkId: string
) => {
  const payload = {
    walletAddress,
    networkId,
  };
  let url = `/user/loginAndSignup`;
  const response = await Api.post(url, payload);
  return response;
};

export const walletOverviewDetails = async (
  walletAddress: string
) => {
  let url = `/ownerNft/getOwnerOverviewGraphData?ownerAddress=${walletAddress}`;
  const response = await Api.get(url);
  return response;
};
